import { useState, useEffect } from "react";
import Spinner from "../../components/ui/Spinner.component";
import Breadcrumb from "../../components/ui/Breadcrumb.component";
import axios from "axios";

export const PlanPage = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1/sales/subscription/me/`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        setSubscriptionData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [token]);

  if (!subscriptionData) {
    return (
      <div className="w-screen h-screen">
        <div className="flex relative bg-black/[.27]  h-full">
          <div>
            <Breadcrumb
              segments={["Home", "Subscription", "Plans"]}
              paths={["/", "/subscription", "/plans"]}
            />
          </div>
          <div className="absolute top-1/2 left-1/2">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  const organizationEmail = subscriptionData.data.organization_email;

  return (
    <div className="w-full">
      <Breadcrumb
        segments={["Home", "Subscription", "Plans"]}
        paths={["/", "/subscription", "/plans"]}
      />
      <stripe-pricing-table
        pricing-table-id={`${process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}`}
        publishable-key={`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`}
        customer-email={organizationEmail}
      />
    </div>
  );
};
